import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { isStringEmpty } from '../../common/functions';
import { InsectaServiceBase } from './insecta.base.service';
import { ILocation, IOrder, IOrderAddRequest, IOrderUpdateRequest } from './insecta.models';

@Injectable({
  providedIn: 'root'
})
export class OrderService extends InsectaServiceBase {
  public getLocationsForHierarchy(): Observable<ILocation[]> {
    return this.get<ILocation[]>(`/structured`, 'v1');
  }

  public getAllOrder(): Observable<IOrder> {
    return this.get<IOrder>(`/orders`, `v1`);
  }

  public getOrderById(orderId: string): Observable<IOrder> {
    return this.get<IOrder>(`/orders/${orderId}`, `v1`);
  }

  public getOrderStatusById(orderId: string): Observable<string> {
    return this.get<string>(`/orders/${orderId}/status`, `v1`);
  }

  public addOrder(request: IOrderAddRequest): Observable<any> {
    return this.post(`/orders`, 'v1', request);
  }

  public updateOrder(request: IOrderUpdateRequest): Observable<any> {
    return this.put(`/orders/${request.id}`, 'v1', request);
  }

  public getNotificationDetails(): Observable<any> {
    return this.get<any>(`/appusers`, `v1`);
  }

  public setWorkflowStatus(entityType: string, id: string, status: string, option: string | undefined): Observable<any> {
    return isStringEmpty(option)
      ? this.post(`/${entityType}/${id}/${status}`, 'v1', {})
      : this.post(`/${entityType}/${id}/${status}?option=${option}`, 'v1', {});
  }

  public setWorkFlowStatusInstancesOnly(entityType: string, status: string, instancesIds: string[]): Observable<any> {
    return this.post(`/${entityType}/${status}`, 'v1', instancesIds);
  }

  public copyOrder(orderId: string, alternateOwnerJson: string, notificationJson: string): Observable<any> {
    return this.post(`/orders/${orderId}/copy`, 'v1', { alternateOwnerJson, notificationJson });
  }
}
